(function ($) {
  DJ.addBehavior('filterReset', '.filter-speciality-reset', {
    attach: function () {
      const resetButton = this;
      const submitReset = document.querySelector('.form-button-reset');

      /**
       * Return false if no submit reset button.
       */
      if (!submitReset) {
        return false;
      }

      /**
       * Use submit reset value as text for reset button.
       */
      resetButton.textContent = submitReset.value;

      /**
       * Click on the submit reset by clicking reset button.
       */
      resetButton.addEventListener('click', () => {
        submitReset.click();
      });

      return true;
    }
  });
})(jQuery);
